<template>
	<v-dialog v-model="showDialog" max-width="900" overlay-opacity="0.9">
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">部品検索</v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-4">
				<v-form class="pa-2 mt-2" ref="form" lazy-validation>
					<v-text-field
						v-model="searchWord"
						label="部品名で検索"
						hint="部品名を入力してください"
						class="mt-2 mx-1"
						outlined
						dense
					/>

					<v-text-field
						v-model="searchNumber"
						label="部品品番で検索"
						hint="品番を入力してください"
						class="mt-2 mx-1"
						outlined
						dense
					/>

					<v-row no-gutters align="center" justify="space-around">
						<v-btn
							:disabled="!searchWord && !searchNumber"
							class="ma-2 pa-2 mt-4"
							color="primary"
							@click="searchComponents()"
							><v-icon>mdi-magnify</v-icon>検索</v-btn
						>
					</v-row>
				</v-form>
				<div v-if="selectedComponents.length > 0" class="mt-4">
					<h3 class="selected-components">選択された部品</h3>
					<div>
						<v-chip
							close
							@click:close="removeSelectedComponent(component)"
							v-for="component in selectedComponents"
							:key="component.id"
							label
							class="mr-1 mt-1"
						>
							{{ component.name }}
						</v-chip>
					</div>
					<v-btn color="secondary" class="mt-2" @click="selectComponents(selectedComponents)"
						>決定する</v-btn
					>
				</div>

				<div class="table-container mt-6" v-if="openDataTable">
					<v-data-table
						locale="ja-JP"
						:headers="headers"
						:items="components"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
						show-select
						v-model="selectedComponents"
						item-key="id"
					>
						<!-- <template v-slot:item="{ item }">
							<tr>
								<td>{{ item.part_number }}</td>
								<td>{{ item.name }}</td>
							</tr>
						</template> -->
					</v-data-table>
					<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
				</div>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import PaginationModule from "../../../modules/PaginationModule.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			default: false,
		},
	},

	components: {
		PaginationModule,
	},
	data() {
		return {
			searchMatterName: "",
			searchProductNumber: "",
			order_components: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			headers: [
				// { text: "選択", value: "", width: "50px", divider: true },
				{ text: "部品品番", value: "part_number", width: "200px", divider: true },
				{ text: "部品名", value: "name", width: "200px", divider: true },
			],
			openDataTable: false,
			searchNumber: "",
			searchWord: "",
			selectedComponents: [],
		}
	},

	methods: {
		getPage(page) {
			this.searchComponents(page)
		},

		searchComponents(page) {
			const headers = authenticate.setHeader()
			const params = {
				name_cont: this.searchWord,
				part_number_cont: this.searchNumber,
			}
			axios
				.get(`/erp/v1/order_data/search_components`, {
					headers,
					params: { q: params, page },
				})
				.then((res) => {
					this.components = res.data.components
					this.openDataTable = true
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		selectComponents(selectedComponents) {
			const displayBtn = true
			const componentFlag = true
			this.$emit("select-components", selectedComponents, displayBtn, componentFlag)
			this.showDialog = false
		},
		removeSelectedComponent(component) {
			const index = this.selectedComponents.indexOf(component)
			this.selectedComponents.splice(index, 1)
		},
	},

	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
}
</script>
<style lang="scss" scoped>
.selected-components {
	font-weight: bold;
	margin-bottom: 4px;
}
</style>
